import { QUESTION_TYPE } from 'types/question.types';

// Configuration for linear scale question types
export const getLinearScaleTypeInfo = (
  type: QUESTION_TYPE
): { title: string; description: string } => {
  switch (type) {
    case QUESTION_TYPE.NPS:
      return {
        title: 'Net Promoter Score®',
        description:
          "Standardized metric for measuring engagement, specifically an event's quality and relevance"
      };
    case QUESTION_TYPE.SATISFACTION:
      return {
        title: 'Satisfaction score',
        description:
          "Standardized metric for measuring engagement, specifically an event's overall success and ROI"
      };
    case QUESTION_TYPE.CONNECTION:
      return {
        title: 'Connection score',
        description:
          'Standardized metric for measuring engagement, specifically relationship-building and team cohesion'
      };
    case QUESTION_TYPE.RETENTION:
      return {
        title: 'Retention score',
        description:
          'Standardized metric for measuring engagement, specifically sustainability and long-term appeal'
      };
    default:
      return {
        title: 'Linear scale',
        description: 'Collect a number out of a range'
      };
  }
};
